export enum Variant {
  CONFIRMATION = 'confirmation',
  DESTRUCTIVE = 'destructive',
  INFORMATION = 'information',
  DEFAULT = 'default',
}
